import type { DragEndEvent, DragStartEvent } from "@dnd-kit/core";
import { DndContext, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { ComponentPropsWithRef, ReactNode } from "react";

type SortableTransformProps = Omit<ComponentPropsWithRef<"div">, "style"> & {
  transform: ReturnType<typeof useSortable>["transform"];
  transition: ReturnType<typeof useSortable>["transition"];
};

/** Applies the live transform values produced by dnd-kit without exposing inline styles to product code. */
export function SortableTransform({ transform, transition, ...props }: SortableTransformProps): ReactNode {
  return <div {...props} style={{ transform: CSS.Transform.toString(transform), transition }} />;
}

export {
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  SortableContext,
  sortableKeyboardCoordinates,
  useSensor,
  useSensors,
  useSortable,
  verticalListSortingStrategy,
};
export type { DragEndEvent, DragStartEvent };
